import React, { useEffect } from 'react';
import LandingPage1 from './LandingPage1';
import LandingPage2 from './LandingPage2';
import LandingPage3 from './LandingPage3';
import LandingPage4 from './LandingPage4';
import LandingPage5 from './LandingPage5';
import FAQ from './FAQ';
import './MainLandingPage.css';

// Centralized video links for all landing page components
const videoLinks = {
  // LandingPage1 - Hero video
  hero: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221809/a9duklatrsnpcjsbvlbq.mp4",
  
  // LandingPage3 - Feature videos
  features: {
    backdrop: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221809/qpbxgathoanocgrl97rt.mp4",    
    reframe: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221809/bdkz2azz8jnb9n7jgguu.mp4",
    retouch: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221809/fwngwjspk0tjpiukeinf.mp4",
    // Commented out video from original code
    // editMode: "https://res.cloudinary.com/dxfs2irxa/video/upload/v1745407248/004_zac0qk.mp4"
  },
  
  // Use Cases videos (from constants)
  useCases: {
    instantSceneGeneration: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221809/k7q9qxc9vpxeipradlrx.mp4",     
    relightAndMatchMood:"https://res.cloudinary.com/dws2jyiph/video/upload/v1750221810/chqtgzfy56phad14qmtp.mp4",
    seamlessProductSwap: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221810/deru6wqoepq3dhj4txdf.mp4",
    selectiveAddOnsAndEdits: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221810/lm6fc3qgwo9jz7kgp7mu.mp4",
    newAnglesAndEnvironments: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221810/b4t9anasg48lq917bavy.mp4",
    productColorChange: "https://res.cloudinary.com/dws2jyiph/video/upload/v1750221810/ymehablavxpz4hyt3wds.mp4"
  }
};

// Features data moved from LandingPage3
const features = [
  {
    title: "Backdrop",
    description: "Automatically replaces product photo backgrounds with on-brand, photorealistic scenes using AI.",
    points: [
      "Preserves 100% product details",
      "Generates brand-aligned, stunning visuals",
      "Relight Product based on scene",
    ],
    img: "https://storage.googleapis.com/a1aa/image/3424471a-1570-4b65-9b3a-80697408a6cd.jpg",    
    vid: videoLinks.features.backdrop,
    alt: "Light beige sectional sofa with a patterned pillow on a white background",
    reverse: false,
  },
  {
    title: "ReFrame",
    description: "Generate product in diverse environments and in new perspectives and colors",
    points: [
      "Convert 1 product image into endless images",
      "Maintain Product consistency across all images",
      "Reimagine Product in different color and angle",
    ],
    img: "https://storage.googleapis.com/a1aa/image/4dcfbb27-dd22-470c-1e62-d683f8753b73.jpg",
    vid: videoLinks.features.reframe,
    alt: "Gray upholstered chair against a green wooden wall background",
    reverse: true,
  },
  {
    title: "ReTouch",
    description: "Add/Remove/Replace Products or accessories in the scene with magic brush",
    points: [
      "No design skills needed - just freestyle",
      "Added product looks photorealistic",
      "Change color of the product",
    ],
    img: "https://storage.googleapis.com/a1aa/image/7a26e1ef-cbeb-4b7d-3dfb-2a8946967cc3.jpg",
    vid: videoLinks.features.retouch,
    alt: "Blue armchair with wooden legs in a room with beige wall",
    reverse: false,
  },
  // {
  //   title: "Edit Mode",
  //   description: "Easily add or remove products and accessories with an AI-powered brush—no design skills needed, just creativity.",
  //   points: [
  //     "Add trained products or props instantly",
  //     "Remove unwanted items with one click",
  //     "Final image stays brand-aligned, always",
  //   ],
  //   img: "https://storage.googleapis.com/a1aa/image/7a26e1ef-cbeb-4b7d-3dfb-2a8946967cc3.jpg",
  //   vid: videoLinks.features.editMode,
  //   alt: "Blue armchair with wooden legs in a room with beige wall",
  //   reverse: false,
  // },
];

// Testimonials data moved from LandingPage2
const testimonials = [
  {
    images: [
      "/images/Page_2/1/001.png",
      "/images/Page_2/1/002.png",
      "/images/Page_2/1/003.png",
      "/images/Page_2/1/004.png"
    ],
    message: "With Shutter, we went from weeks of planning and studio shoots to creating showroom-quality visuals in just minutes. The AI-generated environments are breathtaking, and I no longer have to compromise between speed and style. It's honestly the smartest tool in my creative arsenal.",
    author: "Jasmine Lee",
    role: "Visual Content Strategist"
  },
  {
    images: [
      "/images/Page_2/2/001.png",
      "/images/Page_2/2/002.png",
      "/images/Page_2/2/003.png",
      "/images/Page_2/2/004.png"
    ],
    message: "Shutter helped us cut down our content creation costs by over 90%. We don't need bulky photo setups or expensive renders anymore — just a few clicks and we have premium visuals ready for our product listings. It's changed the way we launch new collections.",
    author: "Daniel Cortez",
    role: "E-commerce Store Owner"
  },
  {
    images: [
      "/images/Page_2/3/001.png",
      "/images/Page_2/3/002.png",
      "/images/Page_2/3/003.png",
      "/images/Page_2/3/004.png"
    ],
    message: "Our marketing team was blown away by what Shutter could do. It's not just a background generator — it's a full-fledged creative solution. The re-lighting and edit features gave us total control, and the image quality rivals professional photoshoots.",
    author: "Anika Sharm",
    role: "Creative Director, Home Décor Brand"
  },
  {
    images: [
      "/images/Page_2/4/001.png",
      "/images/Page_2/4/002.png",
      "/images/Page_2/4/003.png",
      "/images/Page_2/4/004.png"
    ],
    message: "I used to spend hours fine-tuning 3D furniture renders. With Shutter, I can prototype visual concepts on the fly. The AI handles realism so well that I now use it as a fast-track to client approvals. It's become an essential part of my workflow.",
    author: "Luca Moretti",
    role: "Freelance 3D Artist & Designer"
  }
];

// Images data moved from LandingPage4
const images = [
  {
    src: "/images/gallery/001.jpg",
    alt: "Dining room with table and chairs near window with white walls and wooden floor",
  },
  {
    src: "/images/gallery/002.jpg",
    alt: "Indoor plants hanging and two orange chairs with small round table in front of window",
  },
  {
    src: "/images/gallery/003.jpg",
    alt: "Sunlit room with wooden table and chairs near large windows with plants on table",
  },
  {
    src: "/images/gallery/004.jpg",
    alt: "Modern dining room with round wooden table and chairs with chandelier above",
  },
  {
    src: "/images/gallery/005.jpg",
    alt: "Living room with beige sofa, round coffee table, stairs and large window",
  },
  {
    src: "/images/gallery/006.jpg",
    alt: "Office room with blue wall, wooden desk, chair and shelves with decorations",
  },
  {
    src: "/images/gallery/007.jpg",
    alt: "Single green chair in empty room with plain light walls and floor",
  },
  {
    src: "/images/gallery/008.jpg",
    alt: "Living room with sofa, glass coffee table and dining area in background",
  },
  {
    src: "/images/gallery/009.jpg",
    alt: "Dining room with table and chairs near window with white walls and wooden floor",
  },
  {
    src: "/images/gallery/010.jpg",
    alt: "Cozy reading nook with bookshelf and cushioned chair in warm lighting",
  },
  {
    src: "/images/gallery/011.jpg",
    alt: "White room with wall art, pillows on floor and small white stool",
  }
  // Commented out images
];

// Result images data moved from LandingPage4
 const resultImages = [
  {
    src: "/images/results/before1.jpg",
    alt: "Before image of furniture",
  },
  {
    src: "/images/results/after1.jpg",
    alt: "After image processed by Shutter AI",
  },
  {
    src: "/images/results/before2.jpg",
    alt: "Before image of furniture setup",
  },
  {
    src: "/images/results/after2.jpg",
    alt: "After image with AI enhancements",
  }
];

// FAQ data moved from LandingPage5
 const faqData = [
  {
    id: "faq1",
    question: "Can't ChatGPT or Midjourney do this?",
    answer:
      "No. Tools like ChatGPT or Midjourney can't preserve your exact product. As a furniture brand, accuracy matters—you can't afford misrepresentation. Plus, they offer no control over product styling or placement.",
  },
  {
    id: "faq2",
    question: "Do I need editing skills?",
    answer:
      "Not at all. Just select your product, choose a style, and type a short prompt. Our built-in editor lets you tweak images without any design experience.",
  },
  {
    id: "faq3",
    question: "How long does it take to generate images?",
    answer:
      "Most images are ready in 10–12 seconds, depending on your plan.",
  },
  {
    id: "faq4",
    question: "Is it expensive?",
    answer:
      "Not really. Our basic plan starts at just $50 for 250 credits.",
  },
  {
    id: "faq5",
    question: "How do I get started?",
    answer:
      "You can sign up for a free plan and start right away. Or book a demo and we'll walk you through everything.",
  },
];

// Use cases data moved from constants
export const use_cases = [
  {
      "id": 1,
      "title": "Instant Scene Generation",
      "mode": "Backdrop Mode 1",
      "description": "Generate stunning backgrounds instantly while your product stays exactly as shot—same angle, same lighting. Type a prompt, click, and watch a realistic scene bloom around your item.",
      "video_url": videoLinks.useCases.instantSceneGeneration
  },
  {
      "id": 2,
      "title": "Relight & Match Mood",
      "mode": "Backdrop Mode 2",
      "description": "Need new mood lighting? Our relight engine rebuilds the scene and gently matches product highlights and shadows to it, keeping position unchanged and preserving every detail you love.",
      "video_url": videoLinks.useCases.relightAndMatchMood
  },
  {
      "id": 3,
      "title": "Seamless Product Swap",
      "mode": "Retouch Mode 2",
      "description": "Swap any product inside a photo without retakes. Mask the original, choose the new item, and Shutter Labs inserts it seamlessly, perfectly matching perspective and lighting.",
      "video_url": videoLinks.useCases.seamlessProductSwap
  },
  {
      "id": 4,
      "title": "Selective Add-Ons & Edits",
      "mode": "Retouch Mode 1",
      "description": "Add props, people, or creative touches to an existing shot. Simply mask the area, describe the addition, and our AI blends it in naturally—no full reshoot needed.",
      "video_url": videoLinks.useCases.selectiveAddOnsAndEdits
  },
  {
      "id": 5,
      "title": "New Angles & Environments",
      "mode": "Reframe Mode 2",
      "description": "Show your product from fresh angles and settings automatically. Provide one reference image and a prompt; our engine renders multiple realistic scenes, always keeping shape, texture intact.",
      "video_url": videoLinks.useCases.newAnglesAndEnvironments
  },
  {
      "id": 6,
      "title": "Product Color Change",
      "mode": "Reframe Mode 2 (Beta)",
      "description": "Instantly visualize your product in new colors. Select the product, mention the desired hue, and get a photo-real result that preserves materials and lighting—ideal for rapid style testing.",
      "video_url": videoLinks.useCases.productColorChange
  }
];

const MainLandingPage = () => {
    useEffect(() => {
        sessionStorage.removeItem("username");
        sessionStorage.removeItem("password");
    }, []);
    return (
        <div className="main-landing-container">
            <LandingPage1 videoLinks={videoLinks} />
            <LandingPage2 testimonials={testimonials} />
            <LandingPage3 videoLinks={videoLinks} features={features} />
            <LandingPage4 images={images} resultImages={resultImages} />
            <FAQ faqData={faqData} />
            <LandingPage5 />
        </div>
    )
}
export default MainLandingPage;


